import AbstractTextRepresentationSpecificationVisitor from "../../specification/visitors/AbstractTextRepresentationSpecificationVisitor.js";

/**
 * `textRepresentationAccountSpecificationVisitor` is used to display
 * account specifications in text form.
 */
export default class TextRepresentationAccountSpecificationVisitor extends AbstractTextRepresentationSpecificationVisitor {
	visitAccountIntervalSpecification(aSpecification) {
		return aSpecification.getInterval();
	}

	visitAccountGroupSpecification(aSpecification) {
		return aSpecification.getName();
	}

	visitAccountNumberListSpecification(aSpecification) {
		return aSpecification.getAccountNumbers().join(",");
	}

	visitSingleAccountSpecification(aSpecification) {
		return aSpecification.getNumber();
	}
}
